import type { UpdatePackRequest } from 'app/typings/core/admin/packs/packForm';

import { MenuItemName } from './menuItem';

export const PACK_TAB_FIELDS: Record<
  MenuItemName,
  (keyof UpdatePackRequest | string)[]
> = {
  [MenuItemName.General]: [
    'nameForHotel',
    'aliasForHotel',
    'nameForUser',
    'aliasForUser',
    'channelManagerRateCode',
    'channelManageRateCode',
    'openingHours',
    'isGem',
    'oldPackId',
    'ownerId',
  ],
  [MenuItemName.ExperiencesAndRooms]: [
    'packRooms',
    'packExperiences',
    'experiences',
  ],
  [MenuItemName.Limitations]: [
    'minChargedPax',
    'maxAllowedPax',
    'maxAllowedAdult',
    'maxAllowedChild',
    'maxBookingConfiguration',
  ],
  [MenuItemName.Copywriting]: ['description', 'customTagIds'],
  [MenuItemName.Disclaimer]: ['disclaimers'],
  [MenuItemName.Medias]: [
    'horizontalCoverPicture',
    'verticalCoverPicture',
    'introPictures',
    'packExperiences',
  ],
};
